const AboutTheAssociation = () => {
  return (
    <article>
      <h2 className="text-[#408099] font-bold text-md md:text-lg lg:text-2xl mb-2 md:mb-4">
        نبذة عن الجمعية
      </h2>
      <p>
        تأسست جمعية سيهات للخدمات الاجتماعية من أجل مساعدة المحتاجين من أهالي
        المدينة، من محتاجين وأرامل وأيتام، وعجزة بسبب الظروف الاقتصادية
        والاجتماعية التي عاشتها المنطقة عقب الحرب العالمية الثانية، حيث وردت
        الموافقة على تأسيس جمعية سيهات تحت مسمى صندوق البر في بلدة سيهات بتاريخ
        24 / 10 / 1380 هـ وتم تسجيلها تحت رقم 6 بتاريخ 16 / 11 / 1386 هـ. وتعود
        فكرة التأسيس للحاج عبدالله سلمان المطرود الذي كان بجانبه نفرٌ من الخيرين
        ومحبي العمل التطوعي الإنساني، فقادهم شعورهم النبيل تجاه المعوزين
        والأرامل والأيتام والعجزة، فتم إنشاء أول مكتب للجمعية بالسوق فوضعوا
        الأسس وأعدوا اللوائح التنظيمية والبرامج المساعدة لبدء العمل واتسعت تلك
        الغاية لتنتقل من مرحلة الرعوية إلى التنموية لتحقيق الرؤية التي وضعها
        المؤسسون والداعمون منذ التأسيس في سبيل إرساء تنمية مستدامة من أجل الوطن
        بتنفيذ مشاريع استثمارية من شأنها أن توفر دخلاً دائماً ثابتاً، وباهتمامها
        بمستقبل المستفيد وإخراجه من دائرة العوز والحاجة بدفعه للاعتماد على ذاته،
        وتوفير العيش الكريم له بإرشاده، وتثقيفه، والاهتمام بتعليمه وتأهيله،
        وكذلك توظيفه.
      </p>
    </article>
  );
};

export default AboutTheAssociation;
